import { configureStore } from '@reduxjs/toolkit';
import { modal } from './registration/slices/registrationStepperSlice';

const Store = configureStore({
  reducer: {
    [modal.name]: modal.reducer,
  },
});

export default Store;
